import { useState, useContext } from 'react';

import { Box, Button, Text, useBreakpointValue } from '@chakra-ui/react';

import style from './Subtitle.style';
import { SubtitleProps } from './Subtitle.type';

import { Icon, Link } from '@/components';
import DownloadMobileAppModal from '@/components/molecules/DownloadMobileAppModal';
import { SignInUrls } from '@/constants/signInUrls.constants';
import useTranslation from '@/hooks/useTranslate';
import { Context } from '@/providers/MainContext';

const Subtitle = ({ buttonVariant }: SubtitleProps) => {
  const { t } = useTranslation();
  const { locale } = useContext(Context);

  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);

  const isMobile = useBreakpointValue({ base: true, md: false });

  const handleButtonClick = (e: any) => {
    if (isMobile) {
      e.preventDefault();
      openModal();
    }
  };
  return (
    <Box __css={style.root}>
      <Box __css={style.actionButton}>
        <Button
          as={'a'}
          target={isMobile ? '_self' : undefined}
          href={isMobile ? undefined : '/login'}
          variant={buttonVariant === 'solid' ? 'uaePassWhite' : 'uaePassBlack'}
          leftIcon={
            buttonVariant === 'solid' ? (
              <Icon name="fingerPrint" />
            ) : (
              <Icon name="fingerPrintWhite" />
            )
          }
          onClick={handleButtonClick}
        >
          {t('continue_with_uae_pass')}
        </Button>
      </Box>
      <Box __css={style.vendorSignUp}>
        <Text as="span">{t('not_customer')}</Text>
        <Link
          href={SignInUrls.VENDOR_REGISTRATION[locale] || 'ar'}
          target="_blank"
        >
          {t('sign_up_as_vendor')}
        </Link>
      </Box>
      {isMobile && (
        <DownloadMobileAppModal
          isOpen={isModalOpen}
          onClose={closeModal}
          redirectTo="/login"
        />
      )}
    </Box>
  );
};
export default Subtitle;
